import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import Sidebar from 'react-sidebar'
import Logger from '../stores/Logger'
import {Link} from 'react-router'
import {Glyphicon, Button} from 'react-bootstrap'
import {majorModes} from './Header'
import {listModes} from '../containers/IdeaList'
import './css/Sidebar.css'

const mql = window.matchMedia(`(min-width: 800px)`) //TODO: is 800 the right number?
const mqlSidebar = window.matchMedia(`(min-width: 1456px)`)
const majorModeMql = window.matchMedia(`(min-width: 800px)`) //TODO: is 800 the right number?

class IdeaListSidebar extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mql: mql,
            mqlSidebar: mqlSidebar,
            docked: props.docked,
            open: props.open,
            adjustmentNumber: null,
            majorModeMql: majorModeMql,
            showMajorModeSwitch: majorModeMql.matches,
        }
        this.mediaQueryChanged = this.mediaQueryChanged.bind(this)
        this.mediaQueryChangedSidebar = this.mediaQueryChangedSidebar.bind(this)
        this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this)
        this.toggleOpen = this.toggleOpen.bind(this)
        this.handleShowOptionChange = this.handleShowOptionChange.bind(this)
        this.changeOrder = this.changeOrder.bind(this)
        this.openTab = this.openTab.bind(this)
        this.doHideSidebar = this.doHideSidebar.bind(this)
        this.handleShowOptionCompactChange = this.handleShowOptionCompactChange.bind(this)
        this.handleShowOptionCardChange = this.handleShowOptionCardChange.bind(this)
        this.closeStoredIdeas = this.closeStoredIdeas.bind(this)
    }
    changeOrder(order){
        this.props.stores.prefStore.dashOrder = order
        this.props.stores.prefStore.storeUserPreferences()
    }
    handleMajorModeChange(e){
        const {stores} = this.props
        const {prefStore} = stores
        let theChange = prefStore.openSidebar
        Logger.trackEvent('handleMajorModeChange','majorMode',e)

        if(prefStore.majorMode !== e){
            prefStore.majorMode = e
            if(!(prefStore.viewMode === listModes.compact || prefStore.viewMode===listModes.card)){
                prefStore.viewMode = listModes.compact
            }
            prefStore.storeUserPreferences()
        }
        prefStore.openSidebar = theChange
    }
    handleShowOptionChange(e){
        if(e.target.checked){
            if(this.props.stores.prefStore.dashPref.indexOf(e.target.value)===-1)
                this.props.stores.prefStore.dashPref+=','+e.target.value
        }else{
            let arr = this.props.stores.prefStore.dashPref.split(',')
            for (var i=arr.length-1; i>=0; i--) {
                if (arr[i] === e.target.value) {
                    arr.splice(i, 1)
                }
            }
            this.props.stores.prefStore.dashPref = arr.join(',')
        }
        Logger.trackEvent('handleShowOptionDashChange','dashPref',this.props.stores.prefStore.dashPref)
        this.props.stores.prefStore.storeUserPreferences()
    }
    handleShowOptionCompactChange(e){
        if(e.target.checked){
            if(this.props.stores.prefStore.compactPref.indexOf(e.target.value)===-1)
                this.props.stores.prefStore.compactPref+=','+e.target.value
        }else{
            let arr = this.props.stores.prefStore.compactPref.split(',')
            for (var i=arr.length-1; i>=0; i--) {
                if (arr[i] === e.target.value) {
                    arr.splice(i, 1)
                }
            }
            this.props.stores.prefStore.compactPref = arr.join(',')
        }
        Logger.trackEvent('handleShowOptionCompactChange','compactPref',this.props.stores.prefStore.compactPref)
        this.props.stores.prefStore.storeUserPreferences()
    }
    handleShowOptionCardChange(e){
        if(e.target.checked){
            if(this.props.stores.prefStore.cardPref.indexOf(e.target.value)===-1)
                this.props.stores.prefStore.cardPref+=','+e.target.value
        }else{
            let arr = this.props.stores.prefStore.cardPref.split(',')
            for (var i=arr.length-1; i>=0; i--) {
                if (arr[i] === e.target.value) {
                    arr.splice(i, 1)
                }
            }
            this.props.stores.prefStore.cardPref = arr.join(',')
        }
        Logger.trackEvent('handleShowOptionCardChange','cardPref',this.props.stores.prefStore.cardPref)
        this.props.stores.prefStore.storeUserPreferences()
    }
    onSetSidebarOpen(open){
        this.setState({sidebarOpen: open})
        Logger.trackEvent('onSetSidebarOpen','open',this.props.stores.prefStore.dashPref)
    }
    componentWillMount(){
        majorModeMql.addListener(this.mediaQueryChanged.bind(this))
        mql.addListener(this.mediaQueryChanged)
        mqlSidebar.addListener(this.mediaQueryChangedSidebar)
        this.setState({mql: mql})
        this.setState({majorModeMql: majorModeMql})
        if(this.state.mql.matches === false){
            this.props.stores.prefStore.openSidebar = false
        }
        if (this.state.mql.matches === false){
            this.setState({sidebarOpen: false})
        }
        else {
            this.setState({sidebarOpen: true})
        }
        if (this.state.sidebarOpen !== true && this.state.sidebarOpen !== undefined){
            this.setState({sidebarDocked: mql.matches})
        }
        else {
            this.setState({sidebarDocked: true})
        }
    }
    mediaQueryChanged(){
        this.setState({showMajorModeSwitch: this.state.majorModeMql.matches})
        if (this.props.stores.prefStore.majorMode !== undefined){
            if (this.props.stores.prefStore.majorMode !== 2){
                this.setState({sidebarDocked: this.state.mql.matches})
            }
        }
        else {
            this.setState({sidebarDocked: this.state.mql.matches})
        }
        if (this.props.stores.prefStore.majorMode !== 2){
            if (this.state.sidebarOpen === false){
                this.setState({sidebarDocked: true})
            }
        }
    }
    mediaQueryChangedSidebar(){
        if (!this.state.mqlSidebar.matches){
            this.setState({adjustmentNumber: 71})
        }
        else {
            this.setState({adjustmentNumber: 74})
        }
    }
    componentWillUnmount() {
        this.state.mql.removeListener(this.mediaQueryChanged)
        this.state.mqlSidebar.removeListener(this.mediaQueryChangedSidebar)
        if (this.unwatchAuth) {
            this.unwatchAuth()
            this.unwatchAuth = null
        }
    }
    statusSymbol(){
        const {stores} = this.props
        const {store} = stores
        if (!store.online)
            return <span className='glyphicon glyphicon-ban-circle' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}> </span>
        else if(store.saving && store.online)
            return <span className='glyphicon glyphicon-pencil' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}></span>
        else if(store.showSpinner && store.online)
            return <span className='glyphicon glyphicon-refresh Spinner' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}></span>
        else if(!store.showSpinner && store.online)
            return <span className='glyphicon glyphicon-ok' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}> </span>
        else
            return <span className='glyphicon glyphicon-question-sign' style={{fontSize:20+'px',top:10+'px',left:7.5+'px'}}> </span>
    }
    openTab(link){
        var win = window.open(link, '_blank')
        if (win) {
            //Browser will open a new tab
            win.focus()
        } else {
            //Browser has popups blocked
            alert('Popups on your browser are disabled, re-enable them in order to see the page.')
        }
        Logger.trackEvent('openTab','popupsBlocked',!win)
    }
    doHideSidebar(){
        this.setState({sidebarOpen:false})
        this.props.stores.prefStore.openSidebar = false
        if (this.state.mql.matches === false){
            this.setState({sidebarDocked: true})
        }
        Logger.trackEvent('doHideSidebar')
    }
    toggleOpen(ev){
        Logger.trackEvent('toggleOpen','sidebarOpen',!this.state.sidebarOpen)
        this.setState({sidebarOpen: !this.state.sidebarOpen})
        if(this.state.mql.matches){
            this.setState({sidebarDocked: true })
        }
        else if (this.props.stores.prefStore.majorMode !== undefined){
            if (this.props.stores.prefStore.majorMode !== 2) {
                this.setState({sidebarDocked: false })
            }
        }
        else {
            this.setState({sidebarDocked: true })
        }
        this.props.stores.prefStore.openSidebar = true
        if (ev) {
            ev.preventDefault()
        }
    }
    checkOrder(theOrder){
        const {stores} = this.props
        const {prefStore} = stores
        let order = prefStore.dashOrder
        if (theOrder === order){
            return 'underline'
        }
        else return 'none'
    }
    openStoredIdeas(){
        const {stores} = this.props
        const {routingStore} = stores
        const { push } = routingStore
        push('/idea-storage/')
    }
    closeStoredIdeas(){
        const {stores} = this.props
        const {routingStore} = stores
        const { push } = routingStore
        push('/ideas/')
    }
    render() {
        const {stores} = this.props
        const {store, authStore, routingStore, prefStore} = stores
        const {location} = routingStore
        let value = prefStore.dashPref
        let compactValue = prefStore.compactPref
        let cardValue = prefStore.cardPref
        let team = authStore.auth.primaryTeam
        if(store.itemContent){
            value = store.itemContent
        }
        let showShowOptions = location.pathname.startsWith('/ideas/')
        let backButtonText = prefStore.majorMode === majorModes.ideas ? 'Ideas' : 'Progress'
        let bottomStyling = ''
        let listButtonStyling = ''
        let buttonGlyphStyling = ''
        let containerMargin = 0
        let sidebarMargin = 25
        let boxShadowSetting = "3px 0 0 0px #F0F0F0"
        if (location.pathname.startsWith('/ideas/')){
            if (prefStore.majorMode === majorModes.progress){
                containerMargin = 0
                bottomStyling = 'sidebarBottomDashboard'
                listButtonStyling = 'sidebarListButtonDashboard'
                buttonGlyphStyling = 'dashboardButtonGlyph'
            }else{
                containerMargin = 10
                bottomStyling = 'sidebarBottomCompact'
                listButtonStyling = 'sidebarListButtonCompact'
                buttonGlyphStyling = 'compactButtonGlyph'
            }
        }
        else{
            containerMargin = 10
            bottomStyling = 'sidebarBottomCompact'
            listButtonStyling = 'sidebarListButtonCompact'
            buttonGlyphStyling = 'compactButtonGlyph'

        }
        if (location.pathname.startsWith('/idea-storage/')){
            containerMargin = 0
            sidebarMargin = 0
        }

        let ideasStyle = ''
        let progressStyle = ''

        if(prefStore.majorMode){
            if(prefStore.majorMode === majorModes.ideas){
                ideasStyle = 'activeSidebarButton'
                progressStyle = 'inactiveSidebarButton'
            }else{
                progressStyle = 'activeSidebarButton'
                ideasStyle = 'inactiveSidebarButton'
            }
        }else{
            ideasStyle = 'activeSidebarButton'
            progressStyle = 'inactiveSidebarButton'
        }

        let topAdjustment = 0

        var w = window.innerWidth
        if (!this.state.adjustmentNumber){
            if (prefStore.majorMode === undefined){
                topAdjustment = 70
            }
            else if (w < 1456){
                topAdjustment = 71
            }
            else topAdjustment = 74
        }
        else {
            topAdjustment = this.state.adjustmentNumber
        }

        if (prefStore.majorMode === undefined){
            topAdjustment = 70
        }

        let sidebarContent = null
        let sidebarWidth = 0

        if (prefStore.openSidebar === false){
            sidebarContent =
                <div className='sidebarClosedButton' style={{position: 'absolute',zIndex:800,left: 0+'px',top: 0+'px',height: 100+'%',width:25+'px',backgroundColor: '#ffffff'}} >
                    <Button
                        style={{position: 'fixed',paddingLeft: 3+'px', zIndex:900,height: 100+'%',width:25+'px',outline: 0,backgroundColor: '#ffffff'}}
                        bsStyle='link'
                        onClick={this.toggleOpen}
                    >
                    <h5><Glyphicon glyph='menu-right'/></h5>
                    </Button>
                </div>
            sidebarWidth = 25
        }

        else {
            sidebarContent =
            <div>
                <div>
                    {(this.state.showMajorModeSwitch && (location.pathname.endsWith('/ideas/') || location.pathname.endsWith('/ideas')) && (team.hasOwnProperty('enableDashboard') && team.enableDashboard === true)) &&
                        <div>
                            <div className='sidebarSelectorButtons'>
                                {store.isLoggedIn &&
                                    <div style={{borderWidth: 2 + 'px',  width:170+'px', boxShadow: '1px 1px 1px 1px #cccccc'}}>
                                        <Button className={ideasStyle} onClick={()=>this.handleMajorModeChange(majorModes.ideas)}>Ideas</Button>
                                        <Button style={{paddingLeft: 10+'px'}} className={progressStyle} onClick={()=>this.handleMajorModeChange(majorModes.progress)}>Progress</Button>
                                    </div>
                                }
                            </div>

                        </div>
                    }
                    {location.pathname.endsWith('/idea-storage/') &&
                        <div style={{cursor: 'pointer'}} onClick={() => this.closeStoredIdeas()}>
                            <h4 className='sidebarContent'><Glyphicon glyph='circle-arrow-left' className='sidebarIdeaPageIcons'/>Active ideas</h4>
                        </div>
                    }
                    {!showShowOptions && !location.pathname.endsWith('/idea-storage/') &&
                        <div>
                           <Link to={{ pathname: '/ideas/' }} style={{color: 'white'}} activeStyle={{ textDecoration: 'underline' }}>
                               <h4 className='sidebarContent'><Glyphicon glyph='circle-arrow-left' className='sidebarIdeaPageIcons'/>{backButtonText}</h4>
                           </Link>
                           <hr className='sidebarDivider'/>
                       </div>
                    }
                    {(showShowOptions && prefStore.majorMode===majorModes.progress) &&
                        <div>
                            {(team.hasOwnProperty('enableDashboard') === false || (team.hasOwnProperty('enableDashboard') && team.enableDashboard === false)) &&
                                <div style={{height: 40+'px', width: 10+'px', margingTop: 20+'px'}}/>
                            }
                            <div className='sidebarOverview'>
                                <div style={{paddingBottom: 4+'px'}}><strong>Overview</strong></div>
                                    <span style={{marginBottom: 5+'px', marginTop: 0+'px', cursor: 'pointer', textDecoration: this.checkOrder('Stage')}} onClick={() => this.changeOrder('Stage')}>Stage</span> <br/>
                                    <span style={{marginBottom: 5+'px', marginTop: 0+'px', cursor: 'pointer', textDecoration: this.checkOrder('Tags')}} onClick={() => this.changeOrder('Tags')}>Team Tags</span> <br/>
                                    <span style={{marginBottom: 5+'px', marginTop: 0+'px', cursor: 'pointer', textDecoration: this.checkOrder('Last Updated')}} onClick={() => this.changeOrder('Last Updated')}>Last Updated</span> <br/>
                                    <span style={{marginBottom: 5+'px', marginTop: 0+'px', cursor: 'pointer', textDecoration: this.checkOrder('Recommendation')}} onClick={() => this.changeOrder('Recommendation')}>Recommendation</span> <br/>
                                    {team.hasOwnProperty('members') &&
                                        <span style={{marginBottom: 6+'px', marginTop: 0+'px', cursor: 'pointer', textDecoration: this.checkOrder('Idea owners')}} onClick={() => this.changeOrder('Idea owners')}>Responsible<br/></span>
                                    }
                                    <span style={{marginBottom: 5+'px', marginTop: 0+'px', cursor: 'pointer', textDecoration: this.checkOrder('Due date')}} onClick={() => this.changeOrder('Due date')}>Due Date</span> <br/>
                                </div>
                            <hr className='sidebarDivider'/>
                        </div>
                    }
                    {(showShowOptions && prefStore.hasOwnProperty('majorMode')) &&
                        <div>
                            {prefStore.majorMode > 1 &&
                                <div>
                                    <div className='sidebarContent'><strong>Show</strong></div>
                                    <form className='sidebarIdeaContent'>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='owner' id='owner'
                                                checked={value.indexOf('owner')>-1}
                                                onChange={this.handleShowOptionChange}/>
                                                <span className='sidebarShowContent'>Responsible</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='rec' id='rec'
                                            checked={value.indexOf('rec')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Recommendation</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='tags' id='tags'
                                            checked={value.indexOf('tags')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Tags</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='image' id='image'
                                            checked={value.indexOf('image')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Image</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='teamSize' id='teamSize'
                                            checked={value.indexOf('teamSize')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Team Size</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='stage' id='stage'
                                            checked={value.indexOf('stage')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Stage</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='creationDate' id='creationDate'
                                            checked={value.indexOf('creationDate')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Creation Date</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='lastUpdated' id='lastUpdated'
                                            checked={value.indexOf('lastUpdated')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Last Updated</span><br/>
                                        </div>
                                        <div>
                                            <input className='sidebarCheckbox' type='checkbox' value='dueDate' id='dueDate'
                                            checked={value.indexOf('dueDate')>-1}
                                            onChange={this.handleShowOptionChange}/>
                                            <span className='sidebarShowContent'>Due Date</span><br/>
                                        </div>
                                    </form>
                                    <hr className='sidebarDivider'/>
                                </div>
                            }
                        </div>
                    }
                    {(showShowOptions && prefStore.hasOwnProperty('majorMode')) &&
                        <div>
                            {prefStore.majorMode < 2 &&
                                <div>
                                    {prefStore.viewMode === 1 &&
                                        <div>
                                            <div className='sidebarContent'><strong>Show</strong></div>
                                            <form className='sidebarIdeaContent'>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='owner' id='owner'
                                                        checked={compactValue.indexOf('owner')>-1}
                                                        onChange={this.handleShowOptionCompactChange}/>
                                                        <span className='sidebarShowContent'>Owner</span><br/>
                                                </div>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='rec' id='rec'
                                                        checked={compactValue.indexOf('rec')>-1}
                                                        onChange={this.handleShowOptionCompactChange}/>
                                                        <span className='sidebarShowContent'>Recommendation</span><br/>
                                                </div>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='tags' id='tags'
                                                        checked={compactValue.indexOf('tags')>-1}
                                                        onChange={this.handleShowOptionCompactChange}/>
                                                        <span className='sidebarShowContent'>Tags</span><br/>
                                                </div>
                                            </form>
                                            <hr className='sidebarDivider'/>
                                        </div>
                                    }
                                    {prefStore.viewMode === 3 &&
                                        <div>
                                            <div className='sidebarContent'><strong>Show</strong></div>
                                            <form className='sidebarIdeaContent'>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='owner' id='owner'
                                                    checked={cardValue.indexOf('owner')>-1}
                                                    onChange={this.handleShowOptionCardChange}/>
                                                    <span className='sidebarShowContent'>Owner</span><br/>
                                                </div>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='rec' id='rec'
                                                    checked={cardValue.indexOf('rec')>-1}
                                                    onChange={this.handleShowOptionCardChange}/>
                                                    <span className='sidebarShowContent'>Recommendation</span><br/>
                                                </div>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='tags' id='tags'
                                                    checked={cardValue.indexOf('tags')>-1}
                                                    onChange={this.handleShowOptionCardChange}/>
                                                    <span className='sidebarShowContent'>Tags</span><br/>
                                                </div>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='image' id='image'
                                                    checked={cardValue.indexOf('image')>-1}
                                                    onChange={this.handleShowOptionCardChange}/>
                                                    <span className='sidebarShowContent'>Image</span><br/>
                                                </div>
                                                <div>
                                                    <input className='sidebarCheckbox' type='checkbox' value='desc' id='desc'
                                                    checked={cardValue.indexOf('desc')>-1}
                                                    onChange={this.handleShowOptionCardChange}/>
                                                    <span className='sidebarShowContent'>Description</span><br/>
                                                </div>
                                            </form>
                                            <hr className='sidebarDivider'/>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <div className='sidebarFooterContainer'>
                    {location.pathname.endsWith('/ideas/') &&
                    <div>
                        <div className='sidebarFooter'>
                            <p className='sidebarLink'><Glyphicon glyph='hdd' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openStoredIdeas()}>Stored ideas</a></p>
                            <p className='sidebarLink'><Glyphicon glyph='facetime-video' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/how-to-videos/?lang=en')}>How-To Videos</a></p>
                            <p className='sidebarLink'><Glyphicon glyph='envelope' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/blog/')}>Blog</a></p>
                            <p className='sidebarLink'><Glyphicon glyph='check' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/handelsbetingelser/')}>Terms</a></p>
                            <p className='sidebarLink'><Glyphicon glyph='lock' className='sidebarIdeaPageBottomIcons'/><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do/security-policy/')}>Security</a></p>
                        </div>
                        <div className={bottomStyling}><a style={{cursor: 'pointer', color: '#9b9b9b'}} onClick={()=> this.openTab('https://pre.do')}>© 2019 PRE.DO</a></div>
                    </div>
                    }
                </div>
                        <div style={{position: 'absolute',zIndex:800,left: 220+'px',top: 0+'px',width:30+'px',backgroundColor: 'black'}} >
                        <Button
                            style={{position: 'fixed',zIndex:900,width:30+'px',height: 100+'%',outline: 0,backgroundColor: '#ffffff'}}
                            bsStyle='link'
                            onClick={this.doHideSidebar}
                            className={listButtonStyling}
                        >
                        <h5><Glyphicon className={buttonGlyphStyling} glyph='menu-left'/></h5>
                        </Button>
                    </div>
            </div>
            sidebarWidth = 250
        }

        const sidebarStyles = {
            root: {
                position: 'absolute',
                top: topAdjustment+'px',
              },
            sidebar: {
                backgroundColor: '#ffffff',
                color: '#1e1f20',
                width: sidebarWidth+'px',
                zIndex: 990,
                top: 0,
                marginRight: sidebarMargin+'px',
                overflowX: 'hidden',
                boxShadow: boxShadowSetting,
            },
            content: {
                top: 0,
                marginLeft: containerMargin+'px',
                overflowY: 'auto',
            },
            overlay: {
                zIndex: 900,
            },

        }
        return (
            <Sidebar
                sidebar={sidebarContent}
                styles={sidebarStyles}
                shadow={false}
                transitions={false}
                open={true}
                touch={false}
                docked={this.state.sidebarDocked}
                onSetOpen={this.onSetSidebarOpen}
            >
                <div className='ideaListChildrenContainer' style={{position: 'relative'}}>
                    {this.props.children}
                </div>
            </Sidebar>
        )
    }
}
export default inject("stores")(observer(IdeaListSidebar))



// WEBPACK FOOTER //
// ./src/containers/IdeaListSidebar.js